import { SEATING_BROADCAST_ACTION_MAP } from "@shared/constants/enums";

export const REALTIME_SEATING_ACTIONS = {
  SEAT_ASSIGNED: SEATING_BROADCAST_ACTION_MAP.seat_assigned.id,
  SEAT_UNASSIGNED: SEATING_BROADCAST_ACTION_MAP.seat_unassigned.id,
  SEAT_RESERVED: SEATING_BROADCAST_ACTION_MAP.seat_reserved.id,
  SEAT_RELEASED: SEATING_BROADCAST_ACTION_MAP.seat_released.id,
} as const;

export type RealtimeSeatingAction =
  (typeof SEATING_BROADCAST_ACTION_MAP)[keyof typeof SEATING_BROADCAST_ACTION_MAP]["id"];

export type RealtimeSeatData = {
  permission_id: number;
  seat_id?: number;
  ticket_type_id?: number | null;
  membership_benefit_id?: number | null;
  membership_level_id?: number | null;
  seat_identifier?: string;
  location_identifier?: string;
  segment_identifier?: string;
};

export type RealtimeSeatingMessage = {
  message_id: string;
  action: RealtimeSeatingAction;
  data: {
    seats: RealtimeSeatData[];
  };
  event_id?: number;
  membership_group_id?: number;
  timestamp: string;
  basket_id?: number;
};
